import { createMedia } from '@artsy/fresnel';
import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { Grid, Icon, Input, Menu } from 'semantic-ui-react';
import { useWikiSearch } from './WikiSearchContext';

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    sm: 0,
    md: 768,
    lg: 1024,
    xl: 1192,
  },
});

const WikiNav = () => {
  const color = 'blue';
  const {
    searchTerm,
    setSearchTerm,
    currentMatchIndex,
    setCurrentMatchIndex,
    totalMatches,
  } = useWikiSearch();

  // Add CSS for active tab styling and accordion titles
  const activeTabStyle = `
    #wiki-menu .wiki-nav-active,
    #wiki-menu .wiki-nav-active span {
      color: #4dabf7 !important;
      font-weight: bold !important;
    }

    .ui.styled.accordion .title {
      font-size: 1.2em !important;
      border-bottom: 1px solid #ddd !important;
      padding-bottom: 0.5em !important;
      background-color: #f8f9fa !important;
      padding: 0.8em 1em !important;
      margin-bottom: 0.5em !important;
    }
  `;

  const handleNext = () => {
    if (totalMatches > 0) {
      setCurrentMatchIndex((currentMatchIndex + 1) % totalMatches);
    }
  };

  const handlePrevious = () => {
    if (totalMatches > 0) {
      setCurrentMatchIndex(
        (currentMatchIndex - 1 + totalMatches) % totalMatches,
      );
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleNext();
    }
  };

  return (
    <MediaContextProvider>
      <style>{activeTabStyle}</style>
      <Grid.Column width={16}>
        <Menu fluid widths={4} id="wiki-menu">
          <Menu.Item
            color={color}
            as={NavLink}
            to="/wiki"
            exact
            activeClassName="wiki-nav-active"
          >
            <Media lessThan="md" as={Icon}>
              <Icon name="home" size="large" />
            </Media>
            <Media greaterThanOrEqual="md">
              <span>Home</span>
            </Media>
          </Menu.Item>

          <Menu.Item
            color={color}
            as={NavLink}
            to="/guides"
            id="dark-blue"
            activeClassName="wiki-nav-active"
          >
            <Media lessThan="md" as={Icon}>
              <Icon name="map outline" size="large" />
            </Media>
            <Media greaterThanOrEqual="md">
              <span>Guides</span>
            </Media>
          </Menu.Item>

          <Menu.Item
            color={color}
            as={NavLink}
            to="/handbooks"
            activeClassName="wiki-nav-active"
          >
            <Media lessThan="md" as={Icon}>
              <Icon name="book" size="large" />
            </Media>
            <Media greaterThanOrEqual="md">
              <span>Handbooks</span>
            </Media>
          </Menu.Item>

          <Menu.Item
            color={color}
            as={NavLink}
            to="/resources"
            id="dark-blue"
            activeClassName="wiki-nav-active"
          >
            <Media lessThan="md" as={Icon}>
              <Icon name="file alternate outline" size="large" />
            </Media>
            <Media greaterThanOrEqual="md">
              <span>Resources</span>
            </Media>
          </Menu.Item>
        </Menu>

        <div
          style={{
            backgroundColor: '#fff',
            padding: '1em 0',
            borderBottom: '1px solid #ddd',
            marginBottom: '1em',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5em',
          }}
        >
          <Input
            icon="search"
            placeholder="Search wiki..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
            style={{ flex: 1 }}
          />
          {searchTerm && totalMatches > 0 && (
            <>
              <span style={{ whiteSpace: 'nowrap', fontSize: '0.9em' }}>
                {currentMatchIndex + 1} / {totalMatches}
              </span>
              <Icon
                name="chevron up"
                link
                onClick={handlePrevious}
                style={{ cursor: 'pointer' }}
                title="Previous match"
              />
              <Icon
                name="chevron down"
                link
                onClick={handleNext}
                style={{ cursor: 'pointer' }}
                title="Next match (Enter)"
              />
            </>
          )}
        </div>

        <Grid.Row />
      </Grid.Column>
    </MediaContextProvider>
  );
};

export default memo(WikiNav);
